import { useAppDispatch } from "app/hooks";
import FormType from "enums/FormType";
import { Assessment } from "features/scorable/Assessment";
import { loadScorable } from "features/scorable/scorableSlice";
import { useCallback, useEffect } from "react";
import embeddingService from "services/embeddingService";
import windowEventService from "services/windowEventService";

export function AssessmentRoute() {
    const dispatch = useAppDispatch();

    const onAssessmentDataReceived = useCallback(
        (event: MessageEvent) => {
            const messageData = event.data;
            if (
                event.source === window.parent &&
                messageData.type == "set-assessment-data"
            ) {
                dispatch(
                    loadScorable({
                        formType: FormType.ASSESSMENT,
                        assignmentData: messageData.assignmentData,
                    })
                ).then((e) => {
                    if ("error" in e) {
                        embeddingService.notifyErrors(
                            "assessment-loading-failed"
                        );
                    } else {
                        embeddingService.sendFormLoadedStatus(true);
                    }
                });
            }
        },
        [dispatch]
    );
    useEffect(() => {
        windowEventService.registerEvent(
            "assessment-form-data-received-event-listener",
            "message",
            onAssessmentDataReceived
        );

        embeddingService.sendFormReadyStatus(true);

        return () => {
            windowEventService.removeEvent(
                "assessment-form-data-received-event-listener",
                "message"
            );
        };
    }, [dispatch, onAssessmentDataReceived]);

    return <Assessment />;
}
